module.exports = __webpack_public_path__ + "static/img/tubka_g.5932d2f8.png";